module.exports = __webpack_public_path__ + "static/media/voice.51b89e30.png";